<template>
	<div class=" padding-left-30 padding-right-30 padding-bottom-30">
		<div class="vctb-list">
			<div class="vctb-item" :class="{'vctb-item-active':vctbIndex==0}" @click="vctbIndex=0">
				资质证书 ({{qualification.totalnum}})
			</div>
			<div class="vctb-item" :class="{'vctb-item-active':vctbIndex==1}" @click="vctbIndex=1">
				人员信息 ({{people.totalnum}})
			</div>
			<div class="vctb-item" :class="{'vctb-item-active':vctbIndex==2}" @click="vctbIndex=2">
				申请/审查信息 ({{check.totalnum}})
			</div>
		</div>


		<div class="padding-left-10 padding-right-10 ">
			<template v-if="vctbIndex==0">
				<div class="box5 box2_cc">
					<div class="box5_text2 text-bold">证书类别</div>
					<div class="box5_text2 text-bold">证书名称 </div>
					<div class="box5_text2 text-bold">证书编号</div>
					<div class="box5_text2 text-bold width-100" style="flex:none;">发证日期</div>
					<div class="box5_text2 text-bold width-100" style="flex:none;">发证有效期</div>
					<div class="box5_text2 text-bold width-80 justify-center" style="flex:none;">操作</div>
				</div>
				<div v-for="(item, index) in qualification_list" :key="index" class="box5">
					<div class="box5_text2">{{ item.type|| '--' }} </div>
					<div class="box5_text2">{{ item.name|| '--' }} </div>
					<div class="box5_text2">{{ item.number|| '--' }} </div>
					<div class="box5_text2 width-100" style="flex:none;">{{ item.date|| '--' }}</div>
					<div class="box5_text2  width-100" style="flex:none;">{{ item.end_date|| '--' }}</div>
					<div class="box5_text2  justify-center  width-80  " style="flex:none;">
						<span class="cpoint" style="color: #0070c0;" @click="showZs(item)">详情</span>
					</div>
				</div>
				<div class="padding-bottom-40" v-if="!qualification_list.length">
					<nomore></nomore>
				</div>

				<div  class="text-right" style="padding: 10px 0">
					<el-pagination background :page-size="qualification.pagesize" :page-sizes="pageSizes"
						:hide-on-single-page="false" layout="prev, pager, next,sizes"
						@size-change="handleSizeChange($event,'qualification')"
						@current-change="handleCurrentChange($event,'qualification')" :current-page="currentPage"
						:total="qualification.totalnum">
					</el-pagination>
				</div>
			</template>

			<template v-if="vctbIndex==1">
				<div class="flex justify-between align-center toptitle" style="margin-top: 8px;">
					<div class="topleft">人员信息<span class="rinum"></span></div>
				</div>
				<div v-if="detail">
					<div class="box5 box2_cc">
						<div class="box5_text2 text-bold">姓名</div>
						<div class="box5_text2 text-bold">人员类别 </div>
						<div class="box5_text2 text-bold">人员证书编号</div>
						<div class="box5_text2 text-bold width-100" style="flex:none;">发证日期</div>
						<div class="box5_text2 text-bold width-100" style="flex:none;">发证有效期</div>
						<div class="box5_text2 text-bold width-80 justify-center" style="flex:none;">操作</div>
					</div>
					<!-- detail.majorpeople -->
					<div v-for="(item, index) in people_list" :key="index" class="box5">
						<div class="box5_text2">{{ item.name|| '--' }} </div>
						<div class="box5_text2">{{ item.type|| '--' }} </div>
						<div class="box5_text2">{{ item.personCertId }} </div>
						<div class="box5_text2 width-100" style="flex:none;">{{ item.startDate|| '--' }}</div>
						<div class="box5_text2  width-100" style="flex:none;">{{ item.endDate|| '--' }}</div>
						<div class="box5_text2  justify-center  width-80  " style="flex:none;">
							<span class="cpoint" style="color: #0070c0;" @click="showRy(item)">详情</span>
						</div>
					</div>
					<div class="padding-bottom-40" v-if="!people_list.length">
						<nomore></nomore>
					</div>

					<div  class="text-right" style="padding: 10px 0">
						<el-pagination background :page-size="people.pagesize" :page-sizes="pageSizes"
							:hide-on-single-page="false" layout="prev, pager, next,sizes"
							@size-change="handleSizeChange($event,'people')"
							@current-change="handleCurrentChange($event,'people')" :current-page="currentPage"
							:total="people.totalnum">
						</el-pagination>
					</div>
				</div>
			</template>

			<template v-if="vctbIndex==2">
				<div v-if="detail">
					<div class="box5 box2_cc">
						<div class="box5_text2 text-bold">资质申请事项</div>
						<div class="box5_text2 text-bold">申请事项审查决定 </div>
						<div class="box5_text2 text-bold">审查决定原因</div>
						<div class="box5_text2 text-bold  ">审查决定公告日期</div>
					</div>
					<!-- detail.majorpeople -->
					<div v-for="(item, index) in check_list" :key="index" class="box5">
						<div class="box5_text2">{{ item.content|| '--' }} </div>
						<div class="box5_text2">{{ item.result|| '--' }} </div>
						<div class="box5_text2">{{ item.reason|| '--' }} </div>
						<div class="box5_text2">{{ item.time|| '--' }}</div>
					</div>
					<div class="padding-bottom-40" v-if="!check_list.length">
						<nomore></nomore>
					</div>

					<div class="text-right" style="padding: 10px 0">
						<el-pagination background :page-size="check.pagesize" :page-sizes="pageSizes"
							:hide-on-single-page="false" layout="prev, pager, next,sizes"
							@size-change="handleSizeChange($event,'check')"
							@current-change="handleCurrentChange($event,'check')" :current-page="currentPage"
							:total="check.totalnum">
						</el-pagination>
					</div>
				</div>
			</template>

		</div>



		<el-dialog title="资质证书详情" :visible.sync="zsShow">
			<table class="pure-table pure-table-bordered">
				<tbody>
					<tr>
						<td style="width:40%;background: #F7F7F7;">证书类别</td>
						<td>{{zsData.type||"--" }}</td>
					</tr>
					<tr>
						<td style=" background: #F7F7F7;">证书名称</td>
						<td>{{zsData.name||"--" }}</td>
					</tr>
					<tr>
						<td style=" background: #F7F7F7;">证书编号</td>
						<td>{{zsData.number || '--'}}</td>
					</tr>
					<tr>
						<td style=" background: #F7F7F7;">发证日期</td>
						<td>{{zsData.date|| '--'}}</td>
					</tr>
					<tr>
						<td style=" background: #F7F7F7;">证书状态</td>
						<td>{{zsData.status|| '--'}}</td>
					</tr>
					<tr>
						<td style=" background: #F7F7F7;">发证机构</td>
						<td>{{zsData.agency|| '--'}}</td>
					</tr>
					<tr>
						<td style=" background: #F7F7F7;">业务范围</td>
						<td>{{zsData.formatScope ||'--'}}</td>
					</tr>
					<tr>
						<td style=" background: #F7F7F7;">证书上报日期</td>
						<td>{{zsData.shangbaoDate|| '--'}}</td>
					</tr>
					<tr>
						<td style=" background: #F7F7F7;">证书体系覆盖人数</td>
						<td>{{zsData.payedDate|| '--'}}</td>
					</tr>
				</tbody>
			</table>
		</el-dialog>


		<el-dialog title="人员详情" :visible.sync="ryShow">
			<table class="pure-table pure-table-bordered">
				<tbody>
					<tr>
						<td style="width:40%;background: #F7F7F7;">姓名</td>
						<td>{{ryData.name||"--" }}</td>
					</tr>
					<tr>
						<td style=" background: #F7F7F7;">人员类别</td>
						<td>{{ryData.type||"--" }}</td>
					</tr>
					<tr>
						<td style=" background: #F7F7F7;">人员证书编号</td>
						<td>{{ryData.personCertId || '--'}}</td>
					</tr>
					<tr>
						<td style=" background: #F7F7F7;">发证日期</td>
						<td>{{ryData.startDate|| '--'}}</td>
					</tr>
					<tr>
						<td style=" background: #F7F7F7;">到期日期</td>
						<td>{{ryData.endDate|| '--'}}</td>
					</tr>
					<tr>
						<td style=" background: #F7F7F7;">证书状态</td>
						<td>{{zsData.status|| '--'}}</td>
					</tr>
					<tr>
						<td style=" background: #F7F7F7;">发证机构</td>
						<td>{{zsData.issueAgency|| '--'}}</td>
					</tr>

					<!-- <tr>
						<td style=" background: #F7F7F7;">证书上报日期</td>
						<td>{{zsData.shangbaoDate|| '--'}}</td>
					</tr> -->

				</tbody>

			</table>

		</el-dialog>

	</div>

</template>

<script>
	export default {
		props: {
			id: {
				type: [String, Number],
				default: ""
			},
			detail: {
				type: Object,
				default: ""
			}
		},
		data() {
			return {
				qualification_list: [],
				totalnum: 0,
				currentPage: 1,
				pagesize: 15,
				type: 0,
				vctbIndex: 0,
				zsShow: false,
				zsData: {},
				qualification: {
					currentPage: 1,
					pagesize: 10,
					type: 0,
					totalnum: 0
				},

				people: {
					currentPage: 1,
					pagesize: 10,
					type: 0,
					totalnum: 0
				},
				people_list: [],
				ryShow: false,
				ryData: {},

				check: {
					currentPage: 1,
					pagesize: 10,
					type: 0,
					totalnum: 0
				},
				check_list: [],
				checkShow: false,
				checkData: {},
				totalnum1: 0,
				pageSizes: [10, 20, 30, 40, 50]
			}
		},
		methods: {
			showZs(e) {
				this.zsData = e
				this.zsShow = true;
			},
			showRy(e) {
				this.ryData = e
				this.ryShow = true;
			},
			getlist() {
				var api = this.$api.api.companydata.qualification_list;
				this.$https.post({
						api: api,
						type: "formData",
					}, {
						start: this.qualification.currentPage,
						page_size: this.qualification.pagesize,
						id: this.id
					},
					(response) => {
						// console.log("response", response);
						if (response.data) {
							this.qualification_list = response.data;
							this.qualification.totalnum = response.count;
						}
					},
					(error) => {
						// console.log(error);
					}
				);
			},
			getpersonlist() {
				this.$https.post({
						api: this.$api.api.interfacenew.person_list,
						type: "formData",
					}, {
						start: this.people.currentPage,
						page_size: this.people.pagesize,
						id: this.id
					},
					(response) => {
						console.log("response", response);
						if (response.data) {
							this.people_list = response.data;
							this.people.totalnum = response.count;
						}
					},
					(error) => {
						// console.log(error);
					}
				);
			},
			getCheckList() {
				this.$https.post({
						api: this.$api.api.interfacenew.check_list,
						type: "formData",
					}, {
						start: this.check.currentPage,
						page_size: this.check.pagesize,
						id: this.id
					},
					(response) => {
						// console.log("response", response);
						this.check_list = response.data;
						this.check.totalnum = response.count;

					},
					(error) => {
						// console.log(error);
					}
				);
			},
			handleCurrentChange(currentPage, key) {
				this[key].currentPage = currentPage
				if (key == 'qualification') {
					this.getlist();
				} else if (key == 'people') {
					this.getpersonlist()
				} else if (key == 'check') {
					this.getCheckList()
				}

			},
			handleSizeChange(size, key) {
				this[key].pagesize = size
				this[key].currentPage = 1
				if (key == 'qualification') {
					this.getlist();
				} else if (key == 'people') {
					this.getpersonlist()
				} else if (key == 'check') {
					this.getCheckList()
				}
			},
			getNumber() {
				let num = 0
				if (this.qualification.totalnum) num += this.qualification.totalnum
				else if (this.people.totalnum) num += this.people.totalnum
				else if (this.check.totalnum) num += this.check.totalnum
				this.$emit("rNum", num)
			},toout(href) {
				// console.log(href)
				if (!href) {
					return false;
				}
				window.open(href)
			},
		},
		created() {
			this.getlist();
			this.getpersonlist();
		}
	}
</script>

<style lang="scss" scoped>
	@import '../detailcss.scss';
</style>



// WEBPACK FOOTER //
// certificate-page.vue?7f02fc55